import Link from 'next/link'
import { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { CONTACT_REQUEST_URL } from '~/core/constants/url'
import { Button } from '~/core/ui/Button'
import LPContainer from '../LandingPage/LPContainer'

const HeroSection: FC = () => {
  const { t, i18n } = useTranslation()

  return (
    <div className="relative overflow-hidden bg-white">
      <LPContainer>
        <div className="gap-10 self-stretch py-[68px] tablet:py-20 desktop:py-20 text-center max-w-4xl mx-auto">
          <div className="mb-6 animate-fadeInUp text-center w-[343px] tablet:w-[857px] mx-auto">
            {/* Mobile Version */}
            <div className="text-gray-900 text-4.5xl font-semibold leading-[39px] mb-2 tablet:hidden">
              <h3>Empower your </h3>
              <h3>people. Unlock</h3>
              <h3 className="whitespace-nowrap">
                <span
                  className="bg-gray-900 text-white rounded-full inline-block text-center text-4.5xl leading-[39px] font-semibold mx-2 my-2"
                  style={{ padding: '6px 24px 12px 24px' }}>
                  intelligent
                </span>{' '}
              </h3>
              workforce
            </div>

            {/* Desktop/Tablet Version */}
            <div className="hidden tablet:block text-gray-900 text-[61px] font-semibold leading-[61px] mb-2">
              <h3>Empower your people.</h3>
              <h3 className="whitespace-nowrap">
                Unlock{' '}
                <span
                  className="bg-gray-900 text-white rounded-full inline-block text-center text-[61px] font-semibold leading-[61px]"
                  style={{ padding: '6px 24px 12px 24px' }}>
                  intelligent
                </span>{' '}
                workforce
              </h3>
            </div>
          </div>
          <p className="mb-6 desktop:mb-10 font-medium text-xl desktop:text-1.5xl text-gray-700 w-full animate-fadeInUp">
            {t('lp:talent_ai:hero:description')}
          </p>
          <Link
            href={CONTACT_REQUEST_URL}
            locale={i18n?.language}
            className="animate-fadeInUp flex justify-center">
            <Button size="xl" label={`${t('lp:request_demo')}`} />
          </Link>
        </div>
        {/* Illustration placeholder */}
        <picture className="flex justify-center max-w-[1012px] mx-auto">
          <source
            media="(min-width: 768px)"
            srcSet="/img/feature/lp/d-illus.png"
          />
          <source
            media="(max-width: 767px)"
            srcSet="/img/feature/lp/m-illus.png"
          />
          <img alt="Talent AI Hero" loading="lazy" />
        </picture>
      </LPContainer>
    </div>
  )
}

export default HeroSection
